import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reimpostata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm gz-fade-up">
        <h2 className="font-heading text-2xl font-bold text-slate-900">Nuova password</h2>
        <p className="mt-1 text-sm text-slate-500">Scegli una nuova password per il tuo account.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Nuova password</Label>
            <Input
              id="password"
              type="password"
              data-testid="reset-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              required
            />
          </div>
          {error && <p className="text-sm text-red-700">{error}</p>}
          <Button type="submit" disabled={loading || !token} data-testid="reset-submit-button" className="w-full bg-[#14382C] hover:bg-[#0E281F]">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Reimposta password
          </Button>
          {!token && <p className="text-sm text-amber-700">Link non valido: token mancante.</p>}
          <div className="text-center">
            <Link to="/login" className="inline-flex items-center gap-2 text-sm text-[#166534] hover:underline">
              <ArrowLeft className="h-4 w-4" /> Torna all'accesso
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
